/**
 * @generated SignedSource<<3bf5670d7c0a87720b83b8f92bb2067b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewInfo_data$data = {
  readonly currentbenchmarktext: string | null | undefined;
  readonly currentperformancetext: string | null | undefined;
  readonly pabenchmarktext: string | null | undefined;
  readonly paperformancetext: string | null | undefined;
  readonly " $fragmentType": "PerformanceOverviewInfo_data";
};
export type PerformanceOverviewInfo_data$key = {
  readonly " $data"?: PerformanceOverviewInfo_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewInfo_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceOverviewInfo_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentperformancetext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentbenchmarktext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paperformancetext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pabenchmarktext",
      "storageKey": null
    }
  ],
  "type": "PerformanceOverviewInfo",
  "abstractKey": null
};

(node as any).hash = "d5969c572f6f7db77b1d4078af2531e8";

export default node;
